module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "columns",
    staticStyle: {
      "margin": "0px 10px"
    }
  }, _vm._l((_vm.firstFiveCryptoCurrencies), function(cryptoCurrency) {
    return _c('div', {
      staticClass: "column"
    }, [_c('router-link', {
      attrs: {
        "to": ("/" + (cryptoCurrency.id))
      }
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-image",
      class: {
        'card-image-iframe': _vm.isOpenedInIFrame
      }
    }, [_c('figure', {
      staticClass: "image is-4by3"
    }, [_c('img', {
      attrs: {
        "src": ("/static/" + (cryptoCurrency.id) + "_logo.png")
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-content"
    }, [_c('p', {
      staticClass: "title is-5",
      class: {
        'title-iframe': _vm.isOpenedInIFrame
      }
    }, [_vm._v(_vm._s(cryptoCurrency.name))]), _vm._v(" "), _c('p', {
      staticClass: "title price-title is-5",
      class: {
        'price-title-iframe': _vm.isOpenedInIFrame
      }
    }, [_vm._v("$" + _vm._s(_vm.getPriceUSD(cryptoCurrency)) + " \n              "), _c('span', {
      class: {
        'positive-percent-change': cryptoCurrency.positivePercentChange, 'negative-percent-change': !cryptoCurrency.positivePercentChange
      }
    }, [_vm._v(" " + _vm._s(_vm.getPercentChange(cryptoCurrency)) + "% \n                "), _c('icon', {
      staticClass: "arrow-up",
      attrs: {
        "name": "arrow-up",
        "height": "9",
        "width": "9"
      }
    }), _vm._v(" "), _c('icon', {
      staticClass: "arrow-down",
      attrs: {
        "name": "arrow-down",
        "height": "9",
        "width": "9"
      }
    })], 1)])])])])], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "columns",
    staticStyle: {
      "margin": "0px 10px"
    }
  }, _vm._l((_vm.secondFiveCryptoCurrencies), function(cryptoCurrency) {
    return _c('div', {
      staticClass: "column"
    }, [_c('router-link', {
      attrs: {
        "to": ("/" + (cryptoCurrency.id))
      }
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-image",
      class: {
        'card-image-iframe': _vm.isOpenedInIFrame
      }
    }, [_c('figure', {
      staticClass: "image is-4by3"
    }, [_c('img', {
      attrs: {
        "src": ("/static/" + (cryptoCurrency.id) + "_logo.png")
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-content"
    }, [_c('p', {
      staticClass: "title is-5",
      class: {
        'title-iframe': _vm.isOpenedInIFrame
      }
    }, [_vm._v(_vm._s(cryptoCurrency.name))]), _vm._v(" "), _c('p', {
      staticClass: "title price-title is-5",
      class: {
        'price-title-iframe': _vm.isOpenedInIFrame
      }
    }, [_vm._v("$" + _vm._s(_vm.getPriceUSD(cryptoCurrency)) + "  \n              "), _c('span', {
      class: {
        'positive-percent-change': cryptoCurrency.positivePercentChange, 'negative-percent-change': !cryptoCurrency.positivePercentChange
      }
    }, [_vm._v(" " + _vm._s(_vm.getPercentChange(cryptoCurrency)) + "% \n                "), _c('icon', {
      staticClass: "arrow-up",
      attrs: {
        "name": "arrow-up",
        "height": "9",
        "width": "9"
      }
    }), _vm._v(" "), _c('icon', {
      staticClass: "arrow-down",
      attrs: {
        "name": "arrow-down",
        "height": "9",
        "width": "9"
      }
    })], 1)])])])])], 1)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fe49311","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/body/BodyHero.vue
// module id = 1070
// module chunks = 1